import { Box } from '@amzn/meridian';
import type { FC, ReactNode } from 'react';

type MarketplaceBoxProps = {
  borderColor: string;
  backgroundColor: string;
  children: ReactNode;
};

export const MarketplaceBox: FC<MarketplaceBoxProps> = ({ borderColor, children, backgroundColor }) => (
  <div
    style={{
      backgroundColor,
      border: '1.5px solid',
      borderColor,
      borderRadius: '4px',
    }}
  >
    <Box spacingInset="200 300">{children}</Box>
  </div>
);
